import { createSelector } from '@reduxjs/toolkit';

// Partners selectors
export const selectPartners = (state) => state.b2b?.partners?.partners || [];
export const selectSelectedPartner = (state) => state.b2b?.partners?.selectedPartner;
export const selectPartnersPagination = (state) => state.b2b?.partners?.pagination;
export const selectPartnersFilters = (state) => state.b2b?.partners?.filters;
export const selectPartnersLoading = (state) => state.b2b?.partners?.loading || false;
export const selectPartnersError = (state) => state.b2b?.partners?.error;

// Clinics selectors
export const selectClinics = (state) => state.b2b?.clinics?.clinics || [];
export const selectSelectedClinic = (state) => state.b2b?.clinics?.selectedClinic;
export const selectClinicsLoading = (state) => state.b2b?.clinics?.loading || false;
export const selectClinicsError = (state) => state.b2b?.clinics?.error;

// Memoized selectors
export const selectFilteredPartners = createSelector(
  [selectPartners, selectPartnersFilters],
  (partners, filters) => {
    let filtered = [...partners];

    // Apply status filter
    if (filters.status) {
      filtered = filtered.filter((p) => p.status === filters.status);
    }

    // Apply search filter
    if (filters.search) {
      const searchLower = filters.search.toLowerCase();
      filtered = filtered.filter(
        (p) =>
          p.name?.toLowerCase().includes(searchLower) ||
          p.email?.toLowerCase().includes(searchLower) ||
          p.phone?.includes(filters.search)
      );
    }

    return filtered;
  }
);

export const selectActivePartners = createSelector([selectPartners], (partners) =>
  partners.filter((p) => p.status === 'active')
);

export const selectActiveClinics = createSelector([selectClinics], (clinics) =>
  clinics.filter((c) => c.status === 'active')
);

export const selectPartnerById = (id) =>
  createSelector([selectPartners], (partners) => partners.find((p) => p.id === parseInt(id, 10)));

export const selectClinicById = (id) =>
  createSelector([selectClinics], (clinics) => clinics.find((c) => c.id === parseInt(id, 10)));
